import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type {
  EmailResponseForm,
  SubmitEmailResponsePayload,
} from '../../features/email-response/models/email-response.model';

export interface EmailResponseClient {
  getEmailResponseForm(incidentNumber: string): Observable<EmailResponseForm>;
  submitEmailResponse(incidentNumber: string, payload: SubmitEmailResponsePayload): Observable<void>;
}

export const EMAIL_RESPONSE_CLIENT = new InjectionToken<EmailResponseClient>('EMAIL_RESPONSE_CLIENT');

